var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('main',{staticClass:"container-fluid h-100 pa-0"},[(!_vm.userSettingsBusy)?_c('router-view'):_vm._e(),_c('AppLoader',{staticClass:"d-flex loader-overlay",attrs:{"showLoader":_vm.userSettingsBusy}}),_c('UserHandler')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }